
import { defineComponent } from "vue";

export default defineComponent({
  name: "public-page",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
  },
  setup() {
    return { year: new Date().getFullYear() };
  },
});
